import script from "./FieldSet.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldSet.vue?vue&type=script&setup=true&lang=js"

import "./FieldSet.vue?vue&type=style&index=0&id=2e5013e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5013e0"]])

export default __exports__